import { Injectable,EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NotificationsService } from "angular2-notifications";
import { AlertsService, AlertType } from '@jaspero/ng2-alerts';


@Injectable()
export class MessageCenter{

public growlObservable:EventEmitter<any>=new EventEmitter<any>();

public sneakObservable:EventEmitter<any>=new EventEmitter<any>();

public messages:Array<any>=new Array<any>(); 

public stickyGrowlObservable:EventEmitter<any>=new EventEmitter<any>();


constructor (private alert: AlertsService, private notificationService: NotificationsService){

 
// this.alert.create(type,"haha");
  // this.notificationService.info("hello !!","yess");
  // this.spinner.show();
}

public showGrowl( type:string, summary:string,details:string){
  
      this.notificationService[type](summary,details);

}

public showAlert( type:string, message:string){

// 'success' | 'warning' | 'error' | 'info';
let t:AlertType= <AlertType>type;
this.alert.create(t,message);

}

public addMessage(type:string, message:string){
  

}




}


// WEBPACK FOOTER //
// ./src/app/shared/utils/MessagesCenter.ts